import React, { Fragment } from "react";
import {
    Row, Modal, ModalHeader, ModalFooter,
    DropdownToggle, Button, Card, ModalBody
} from 'reactstrap';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
const ShowVoucher = ({ HistoryData, isOpen, toggle }) => {
    const dataTableColumns = [
        {
            Header: 'Voucher Name',
            accessor: 'voucherName',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value}</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'processingFee',
            accessor: 'processingFee',
            Cell: props => <p style={{ marginLeft: "12%" }} >{props.value} %</p>,
            style: { 'whiteSpace': 'unset' }
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: props => <p style={{ marginLeft: "12%" }} > {props.value} </p>,
            style: { 'whiteSpace': 'unset' }
        }
    ];
    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} style={{ maxWidth: "50%" }}><ModalHeader toggle={toggle}>Connected Vouchers</ModalHeader><ModalBody>
                <Row className="col-md-12">
                    <Colxx xxs="12">
                        <Card className="d-flex flex-row mb-3">
                            <Fragment>
                                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                    {HistoryData ? (
                                        <ReactTable
                                            data={HistoryData}
                                            columns={dataTableColumns}
                                            defaultPageSize={5}
                                            filterable={false}
                                            showPageJump={true}
                                            PaginationComponent={DataTablePagination}
                                            showPageSizeOptions={true}
                                            className="-striped -highlight -bordered"

                                            style={{ width: "100%" }}
                                        />
                                    ) : ""
                                    }
                                </div>
                            </Fragment>
                        </Card>
                    </Colxx>
                </Row>
            </ModalBody><ModalFooter>
                    <Button color='primary' onClick={() => toggle()}>Close</Button>
                </ModalFooter></Modal>
        </Fragment>
    );
}
export default ShowVoucher;